import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { WhatYouWant } from '../components/WhatYouWant';
import { MechanismSection } from '../components/MechanismSection';
import { ProductShowcase } from '../components/ProductShowcase';
import { AudienceSection } from '../components/AudienceSection';
import { ClosingSection } from '../components/ClosingSection';
import { StickyBuyBar } from '../components/StickyBuyBar';
import { Footer } from '../components/Footer';
import { CurrencyProvider } from '../contexts/CurrencyContext';
import { PricingPopupProvider } from '../contexts/PricingPopupContext';
import { PricingPopup } from '../components/PricingPopup';
export function SalesPage() {
  return <CurrencyProvider data-id="element-235">
      <PricingPopupProvider data-id="element-236">
        <div className="min-h-screen w-full bg-[#faf6ef] font-sans selection:bg-[#c9a96e] selection:text-[#1e2a4a]" data-id="element-237">
          <Hero data-id="element-238" />

          <div className="flex justify-center py-8 bg-[#faf6ef] text-[#c9a96e]" data-id="element-239">
            <span className="text-2xl opacity-50" data-id="element-240">✦</span>
          </div>

          <ProblemSection data-id="element-241" />

          <div className="flex justify-center py-8 bg-[#faf6ef] text-[#c9a96e]" data-id="element-242">
            <span className="text-2xl opacity-50" data-id="element-243">☽</span>
          </div>

          <WhatYouWant data-id="element-244" />

          <MechanismSection data-id="element-245" />

          <div className="flex justify-center py-8 bg-[#faf6ef] text-[#c9a96e]" data-id="element-246">
            <span className="text-2xl opacity-50" data-id="element-247">✦</span>
          </div>

          <ProductShowcase data-id="element-248" />

          <AudienceSection data-id="element-249" />

          <ClosingSection data-id="element-250" />

          <Footer data-id="element-251" />

          <StickyBuyBar data-id="element-252" />

          <PricingPopup data-id="element-253" />
        </div>
      </PricingPopupProvider>
    </CurrencyProvider>;
}